import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-auth-callback',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SigninCallbackComponent implements OnInit {
  readonly #authService = inject(AuthService);
  readonly #router = inject(Router);

  ngOnInit() {
    this.#authService
      .signinCallback()
      .then(user => {
        const path = user && typeof user.state === 'string' ? user.state : '/projects';
        this.#router.navigateByUrl(path);
      })
      .catch(() => {
        this.#router.navigate(['not-found']);
      });
  }
}
